export class SequenceSubscriptionPersistRequest {
  newEmails: string[];
  removeEmails: string[];

  constructor(newEmails: string[], removeEmails: string[]) {
    this.newEmails = newEmails;
    this.removeEmails = removeEmails;
  }

}
